import React from 'react'
import Toggle from 'react-toggle'

import { AppTheme } from '../types'

export interface Props {
  theme: AppTheme
  onToggle: (theme: AppTheme) => void
}

const ThemeToggle = ({ theme, onToggle }: Props) => {
  return (
    <div className="theme-toggle">
      <Toggle
        checked={theme === 'Light'}
        onChange={() => onToggle(theme === 'Light' ? 'Dark' : 'Light')}
        icons={{
          checked: <i className="icon-night-mode" />,
          unchecked: <i className="icon-day-mode" />,
        }}
      />
    </div>
  )
}

export default ThemeToggle
